import Boton from '../components/Boton'
import Enlace from '../components/Enlace'
import IconoWhatsapp from '../components/IconoWhatsapp'
import Revelar from '../components/Revelar'
import { envios } from '../data/contenido'

function Envios() {
  const numeroWhatsapp = import.meta.env.VITE_WHATSAPP_NUMERO
  const urlWhatsappCta =
    envios.whatsappCta && numeroWhatsapp
      ? `https://wa.me/${numeroWhatsapp}?text=${encodeURIComponent(envios.whatsappCta.mensaje)}`
      : null

  return (
    <section
      id="envios"
      aria-labelledby="titulo-envios"
      className="seccion-y border-t border-oro-profundo/20 bg-carbon"
    >
      <div className="contenedor">
        <Revelar className="max-w-2xl">
          <p className="text-[0.7rem] uppercase tracking-[0.3em] text-oro sm:text-xs sm:tracking-[0.35em]">
            Entrega
          </p>
          <h2 id="titulo-envios" className="mt-4 text-seccion font-light">
            {envios.titulo}
          </h2>
        </Revelar>

        {/* Igual que los pilares: tres columnas a partir de md. Aquí sí se
            pasa por dos en sm porque no hay fondo entre celdas y la tercera
            tarjeta simplemente baja de fila. */}
        <dl className="mt-10 grid gap-8 sm:grid-cols-2 sm:gap-10 md:grid-cols-3">
          {envios.puntos.map((punto, i) => (
            <Revelar key={punto.titulo} retraso={0.08 * i}>
              <div
                className="mb-5 h-px w-12 bg-oro-profundo"
                aria-hidden="true"
              />
              <dt className="font-display text-lg text-oro-claro">
                {punto.titulo}
              </dt>
              <dd className="mt-3 text-sm leading-relaxed text-marfil-suave/80">
                {punto.texto}
              </dd>
            </Revelar>
          ))}
        </dl>

        <Revelar retraso={0.16} className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-4">
          <Enlace
            href={envios.enlaceCompleto.href}
            className="text-sm text-oro-claro underline-offset-4 transition-colors hover:text-oro hover:underline"
          >
            {envios.enlaceCompleto.etiqueta} →
          </Enlace>

          {urlWhatsappCta && (
            <Boton as="a" href={urlWhatsappCta} target="_blank" rel="noopener noreferrer" tamano="sm">
              <IconoWhatsapp />
              {envios.whatsappCta.etiqueta}
            </Boton>
          )}
        </Revelar>
      </div>
    </section>
  )
}

export default Envios
